/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class Policy extends models.PolicyV2Base {
    getFixupPrototypeFunction() { return Policy.fixupPrototype; }

    static newInstance(model: Partial<Policy>): Policy {
        let obj = Object.assign(new Policy(), model);
        Policy.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<Policy>): Policy {
        if (!model) return null;
        return Policy.newInstance(<Policy> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: Policy) {
        if (!obj) return;

        models.Policy.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: Policy): boolean {
        if (models.PolicyV2Base.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, Policy.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
        if (this.auto_remediation_configuration) {
            models.PolicyRemediationConfigurationStatus.fixupPrototype(this.auto_remediation_configuration);
        }
    }

    /**
     * Unique identifier of the policy
     */
    policy_id: string;

    /**
     * Indicates whether the policy is active or inactive
     */
    status: models.PolicyStatus;

    /**
     * Cloud provider(s) associated with the policy
     */
    cloud_providers: Array<models.CloudServiceName>;

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * Unique URI for the policy
     */
    uri: string;

    /**
     * Policy creation time in UTC
     */
    created_at: Date;

    /**
     * Policy last update time in UTC
     */
    updated_at: Date;

    /**
     * User who created the policy
     */
    created_by: string;

    /**
     * User who last updated the policy
     */
    updated_by: string;

    /**
     * Equivalent policies in the policy
     */
    equivalent_policies: Array<string>;

    /**
     * Auto-remediation configuration status for this policy
     */
    auto_remediation_configuration: models.PolicyRemediationConfigurationStatus;

    /**
     * Whether service account / tenant / master-account level values have been configured for this policy's parameters
     */
    is_parameter_configured: boolean;

}
